// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"95":"be3b3614","225":"07bdd995","353":"86b924cb","673":"662e76f5"}[chunkId] + ".css";
};